import React from 'react';

import { Title } from '@gerdau/hefesto/Title';
import { Button } from '@gerdau/hefesto';

import { Header, HeaderActionContainer } from '../styles';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { ERoutes } from '../../../routes';
import {
  Detail,
  DetailContainer,
  DetailContainerTitle,
  DetailContentRow
} from './DetailCard/styles';
import { DetailCard } from './DetailCard';

import { Step } from '@gerdau/hefesto-mais-web/StepByStep/StepByStep.types';
import { DetailSteps } from './DetailSteps';
import { ManifestationDataProps } from '../../../store/ducks/manifestations/types';

interface Props {
  data?: ManifestationDataProps;
  onBack: () => void;
}

const DetailDenied = ({ denied, data }: { denied: boolean; data: string }) => {
  if (!denied) {
    return null;
  }
  return (
    <DetailContainer>
      <DetailContainerTitle>Reclamação negada</DetailContainerTitle>
      <DetailContentRow>
        <DetailCard
          {...{
            title: 'Motivo da negativa',
            subtitle: data
          }}
        />
      </DetailContentRow>
    </DetailContainer>
  );
};

export const ManifestationDetail = ({ data, onBack }: Props) => {
  if (!data) {
    return null;
  }

  const titleWithOrderNumber = `Reclamação nº ${data.orderNumber}`;

  const getBreadcrumbs = () => {
    return [
      { name: 'Manifestações', url: ERoutes.MANIFESTATION },
      {
        name: 'Detalhes da reclamação',
        url: ''
      }
    ];
  };

  const steps: Step[] = [
    { label: 'Reclamacão aberta' },
    { label: 'Reclamação em análise' },
    ...(data.status === 'Devolução do material' ||
    ['divergência do pedido', 'qualidade do material'].includes(
      data?.occurrence?.toLowerCase()
    )
      ? [
          {
            label: 'Devolução do material'
          }
        ]
      : []),
    { label: 'Reclamação resolvida' }
  ];

  const findStepIndexByStatus = (status: string): number => {
    const iconCheckOnAllStatusByPass =
      status === 'Reclamação resolvida' ? 1 : 0;

    const findIndex = steps.findIndex((step) => step.label === status);

    const stepIndex = findIndex >= 0 ? findIndex : 0;

    return stepIndex + iconCheckOnAllStatusByPass;
  };

  const manifestationDenied = data.status === 'Reclamação negada';

  return (
    <>
      <Header headerWithBreadcrumbs withStep={!manifestationDenied}>
        <Breadcrumbs breadcrumbItems={getBreadcrumbs()} onClick={onBack} />
        <Title level={1}>{titleWithOrderNumber}</Title>
        <HeaderActionContainer>
          <span className="subtitle">
            Acompanhe os detalhes da sua reclamação:
          </span>

          <Button name="mock_temporary" onClick={onBack} variant="secondary">
            Listar todas as reclamações
          </Button>
        </HeaderActionContainer>
        <DetailSteps
          steps={steps}
          activeStep={findStepIndexByStatus(data.status)}
          canShow={!manifestationDenied}
        />
      </Header>

      <Detail>
        <DetailContainer>
          <DetailContainerTitle>Resumo da reclamação</DetailContainerTitle>
          <DetailContentRow>
            <DetailCard
              {...{ title: 'Data de criação', subtitle: data.orderCreatedDate }}
            />
            <DetailCard
              {...{ title: 'Horário', subtitle: data.orderCreatedTime }}
            />
            <DetailCard
              {...{ title: 'Status', subtitle: data.status, withTag: true }}
            />
          </DetailContentRow>
        </DetailContainer>
        <DetailContainer>
          <DetailContainerTitle>Detalhes da reclamação</DetailContainerTitle>
          <DetailContentRow>
            <DetailCard
              {...{ title: 'Nome do contato', subtitle: data.contactName }}
            />
            <DetailCard
              {...{ title: 'Telefone', subtitle: data.contactPhone }}
            />
            <DetailCard
              {...{ title: 'Nome do vendedor', subtitle: data.sellerName }}
            />
          </DetailContentRow>
          <DetailContentRow>
            <DetailCard
              {...{ title: 'Ocorrência', subtitle: data.occurrence }}
            />
            <DetailCard
              {...{
                title: 'O veículo está no local?',
                subtitle: data.vehicleOnSite ? 'Sim' : 'Não'
              }}
            />
          </DetailContentRow>
          <DetailContentRow>
            <DetailCard
              {...{
                title: 'Detalhes do ocorrido',
                subtitle: data.manifestationDetails
              }}
            />
          </DetailContentRow>
        </DetailContainer>
        <DetailDenied denied={manifestationDenied} data={data.deniedCause} />
      </Detail>
    </>
  );
};
